module.exports = {
	"title": {
		"artist": "Słuchaj {artistName} na Qobuz",
		"album": "Słuchaj albumu {albumName} {artistName} na Qobuz",
		"track": "Słuchaj {trackName} {artistName} na Qobuz",
		"playlist": "Słuchaj playlisty {playlistName} {ownerName} na Qobuz",
		"focus": "Czytaj tę Panoramę na Qobuz"
	},
	"buttons": {
		"listen": "Słuchaj na Qobuz",
		"buy": "Acheter",
		"share": "Partager",
		"download": "Essayer gratuitement",
		"readmore": "Czytaj więcej",
		"showless": "Afficher moins",
		"showmore": "Zobacz więcej",
		"morealbums": "Plus d'albums sur Qobuz",
		"moreplaylisttrack": "Découvrir la suite sur Qobuz",
		"readfocus": "Czytaj tę Panoramę na Qobuz",
		"seeSubscribes": "Voir les offres d'abonnements"
	},
	"infos": {
		"trackCount": "{count} utwor(y)ów",
		"label": "Label : {label}",
		"composer": "Compositeur : {composer}",
		"producers": "Production",
		"mixers": "Mixage/mastering",
		"diskCount": "{count} albums",
		"duration": {
			"long": "{hours}godz. {minutes}min.",
			"short": "{minutes}min. {seconds}sek."
		},
		"playlist": {
			"private": "Prywatna",
			"public": "Publiczna"
		},
		"hires": "Wysoka jakość",
		"available": "Disponible en"
	},
	"share": {
		"twitter": {
			"track": "Słuchaj {title} według {artist} na Qobuz",
			"album": "Słuchaj {title} według {artist} na Qobuz",
			"artist": "Słuchaj {artist} na Qobuz",
			"playlist": "Słuchaj {playlist} według {owner} na Qobuz",
			"focus": "Czytaj tę Panoramę na Qobuz"
		},
		"mail": {
			"track": {
				"subject": "{title} wyk. przez {artist} jest dostępny na Qobuz!",
				"body": "Słuchaj {title} {artist} z Qobuz w wysokiej jakości: {url}\n\nQobuz to pierwszy serwis do słuchania i pobierania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"album": {
				"subject": "{title} wyk. przez {artist} jest dostępny na Qobuz!",
				"body": "Słuchaj {title} {artist} z Qobuz w wysokiej jakości: {url}\n\nQobuz to pierwszy serwis do słuchania i pobierania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"artist": {
				"subject": "{artist} jest na Qobuz!",
				"body": "Słuchaj {artist} z Qobuz w wysokiej jakości: {url}\n\nQobuz to pierwszy serwis do słuchania i pobierania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"playlist": {
				"subject": "{playlist} według {owner} jest dostępna na Qobuz!",
				"body": "Słuchaj {playlist} de {owner} z Qobuz w wysokiej jakości: {url}\n\nQobuz to pierwszy serwis do słuchania i pobierania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			},
			"focus": {
				"subject": "{title}",
				"body": "Odtwórz {url}\nQobuz to pierwszy serwis do słuchania i pobierania muzyki w wysokiej jakości.\nWięcej informacji i rejestracja na Qobuz.com\n\n"
			}
		},
		"popup": {
			"clickToCopy": "Cliquer pour copier",
			"copy": "Copier",
			"copied": "Copié",
			"link": "Copier le lien suivant pour le partager"
		}
	},
	"tracklist": {
		"title": {
			"track": "Utwór",
			"album": "Utwory albumu",
			"artist": "Top utwory",
			"artist_albums": "Albumy",
			"playlist": "Utwory z playlisty"
		},
		"header": {
			"number": "#",
			"name": "Tytuł",
			"album": "Album",
			"artist": "Artysta",
			"time": "Czas trwania",
			"label": "Wytwórnia muzyczna"
		},
		"media_count": "CD {mediaNumber}",
		"noTracks": "Brak dostępnego utworu"
	},
	"focus": {
		"from": "Według {author}",
		"albumOverlay": " - {releaseYear} - {genre}",
		"joinQobuz": "Rejoignez Qobuz pour lire l'article complet...",
		"signUp": "Essayer gratuitement"
	},
	"playlist": {
		"from": "Par {author}"
	},
	"album": {
		"by": "par",
		"publishedBy": "paru chez"
	},
	"notifications": {
		"nostream": "Les ayant-droits n'ont pas rendu possible l'écoute de cette piste"
	},
	"aside": {
		"title": "A propos"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/pl.json
// module id = 559
// module chunks = 0